angular.module('cvsApp').service('getTokenIDService', ['networkService', 'xdrService', 'configManager',
    'getTokenIDModel', 'cvsAppData', function (NS, XS, CM, GTID, CAD) {

        function getTokenID() {
            this.getTokenID = function (callBackSuccess) {
                var url = CM.getAGPAPIUrl('GET_TOKENID');
                // var params = "&tokenID=" + oTriggerEmail.tokenID +
                // "&emailAddress=" + oTriggerEmail.emailAddress + "&emailTriggerType=" +  oTriggerEmail.emailTriggerType;
                // var url = CM.getApiUrlWithApikey('TRIGGER_EMAIL') + params;
                // var url = CM.getApiUrlWithApikeyAndAppName('TRIGGER_EMAIL', "SPL") + params;

                if (url === "URL_ERROR") {

                } else {
                    var request = {
                        url: url,
                        header: {
                            'Content-Type': 'application/json',
                            'accept': 'application/json'
                        },
                        data: requestBody(),
                        onSuccess: callBackSuccess
                    }
                    cvsUtility.commonServiceCode(url, "getTokenID", GTID, request, callBackSuccess, NS);
                }

            }

            var requestBody = function() {
                var apikey = CAD.getApiKey() || cvsUtility.queryMap.apikey;
                var reqObj = {
                    "getTokenIDRequest": {
                        "header": {
                            "serviceContext": {
                                "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                                "channelName": cvsUtility.queryMap.channel,
                                "lineOfBusiness": "Specialty",
                                "responseFormat": "JSON"
                            },
                            "securityContext": {
                                "apiKey": apikey,
                                "securityType": "apiKey"
                            }
                        },
                        "details": {
                        }
                    }
                };
                return reqObj;

            }

        }

        return new getTokenID();
    }]);